define('home/templates/channelGroupTabCollection',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "<div class=\"carousel\" data-role=\"tabs-container\">\n<div data-action=\"switch-tab\" data-tab=\"all\" class=\"channel-tab__item\">\n<a href=\"/home/explore/"
    + alias1(container.lambda((depth0 != null ? depth0.exploreTab : depth0), depth0))
    + "/all/\" class=\"explore__link\">\n<div class=\"channel-tab__tile text-medium\">\n<strong>"
    + alias1(helpers.gettext.call(depth0 != null ? depth0 : {},"All Categories",{"name":"gettext","hash":{},"data":data}))
    + "</strong>\n</div>\n</a>\n</div>\n</div>\n";
},"useData":true})

});
